import React from 'react';
import { Form, Input } from 'grab-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import cssInput from './input-field.less';
import cssForm from '../form-field.less';

const FormItem = Form.Item;
const Search = Input.Search;

const InputField = ({
  id,
  label,
  placeholder,
  prefix,
  rules,
  type,
  form,
  onChange,
  onBlur,
  isSearchField,
  disabled,
  disableAutoComplete,
  showingRequiredMark,
  showingQuestionCircle,
  normalize,
}) => {
  const { getFieldDecorator } = form;
  const Component = isSearchField ? Search : Input;
  return (
    <FormItem
      label={label}
      className={classnames(cssForm.formItem, cssInput.errorHover, {
        [cssInput.searchField]: isSearchField,
        [cssInput.showingMarkField]: showingRequiredMark,
        [cssInput.inputField]: !showingRequiredMark && !isSearchField,
        [cssInput.showingQuestionCircle]: showingQuestionCircle,
      })}
    >
      {getFieldDecorator(id, {
        rules,
        normalize,
      })(
        <Component
          placeholder={placeholder}
          onChange={onChange}
          type={type}
          autoComplete={disableAutoComplete ? 'new-password' : 'on'}
          disabled={disabled}
          prefix={prefix}
          onBlur={onBlur}
        />,
      )}
    </FormItem>
  );
};

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  prefix: PropTypes.string,
  form: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  placeholder: PropTypes.string,
  rules: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  isSearchField: PropTypes.bool,
  disableAutoComplete: PropTypes.bool,
  showingRequiredMark: PropTypes.bool,
  showingQuestionCircle: PropTypes.bool,
  normalize: PropTypes.func,
};

InputField.defaultProps = {
  label: '',
  style: '',
  placeholder: '',
  prefix: '',
  type: undefined,
  rules: [],
  fieldName: '',
  dataId: '',
  onChange: undefined,
  onBlur: undefined,
  isSearchField: false,
  className: '',
  disabled: false,
  disableAutoComplete: false,
  showingRequiredMark: false,
  showingQuestionCircle: false,
  normalize: undefined,
};

export default InputField;
